import React, { HTMLAttributes, useEffect, useState } from 'react';
import { Link } from './Link';
import { useRouter } from 'next/router';
import { toSentenceCase } from '~/utils/stringUtils';

const USER_ROUTES = [
  'error',
  'forgot-password',
  'login',
  'register',
  'settings'
];
interface BreadcrumbsProps extends HTMLAttributes<HTMLElement> {
  pageTitle?: string;
  path?: string;
  listItemProps?: HTMLAttributes<HTMLElement>;
  linkProps?: HTMLAttributes<HTMLElement>;
}

export function Breadcrumbs({
  pageTitle,
  path,
  listItemProps,
  linkProps,
  ...props
}: BreadcrumbsProps) {
  const router = useRouter();
  const pathToUse = (path ?? router.asPath).split('?')[0];
  let pathSlugs = pathToUse.split('/').filter((slug) => slug !== '');

  const [isUserRoute, setIsUserRoute] = useState(false);

  if (pathSlugs.includes('learning-center')) {
    pathSlugs = pathSlugs.slice(0, 2);
  }

  const titles = pathSlugs.map(
    (slug) => `${slug[0].toUpperCase()}${slug.substring(1).replace(/-/g, ' ')}`
  );
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    const segments = pathToUse.split('/').filter(Boolean);
    if (
      segments.length !== 3 ||
      segments[0] !== 'classrooms' ||
      segments[1] !== 'lesson-library'
    ) {
      setIsUserRoute(false);
      return;
    }

    setIsUserRoute(USER_ROUTES.includes(segments[2]));
  }, [pathToUse]);

  useEffect(() => setFirstRender(false), [firstRender]);

  if (pageTitle) {
    titles.splice(-1, 1, pageTitle);
  }

  return firstRender ? null : (
    <div data-testid="breadcrumbs" {...props}>
      <ul>
        {pathSlugs.map((slug, index) => {
          const shouldHideItem =
            !isUserRoute && pathSlugs.length === 3 && index === 0;

          return shouldHideItem ? null : (
            <li
              key={slug}
              className="inline before:mx-2 before:content-['>'] first:before:content-none"
              {...listItemProps}
            >
              <Link
                path={`/${pathSlugs.slice(0, index + 1).join('/')}`}
                title={toSentenceCase(titles[index])}
                {...linkProps}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
